// extracted by mini-css-extract-plugin
module.exports = {"sideMenuButtonWrapper":"styles_sideMenuButtonWrapper__vhYX4","sideMenuButtonTitle":"styles_sideMenuButtonTitle__IV0Dm","iconContainer":"styles_iconContainer__2OdZA"};